'use strict';

angular.module('ClinicApp').directive('radialMeter', function() {
  return {
    templateUrl: '/views/directives/_radial-meter.html',
    scope: {
      value: '=radialMeter',
      size: '@', // large, small
      color: '@', // white, violet
    },
    link: function($scope) {
      $scope.size = $scope.size || 'large';
      var RADIUS = {
        large: 33,
        small: 17,
        'xs-thick': 13,
      };

      var pathLength = Math.PI * 2 * RADIUS[$scope.size];

      $scope.$watch('value', function() {
        var offset = pathLength - $scope.value * pathLength / 100;
        $scope.fillPathStyle = {
          strokeDasharray: pathLength + 'px',
          strokeDashoffset: offset + 'px',
        };
      });
    },
  };
});
